import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { TableCell, Typography, TableRow, } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useOrgDetailsQuery } from "services/org";
import { useGetRoleByCodeQuery } from "services/role";
import { useUserCognitoDetailsQuery } from 'services/user';

const classes = {
    evenRow: {
        height: "50px",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#d9e6f7"
        },
    },
    oddRow: {
        height: "50px",
        backgroundColor: '#f0f4f9',
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#d9e6f7"
        },
    },
    body2: {
        fontSize: "12px",
        fontWeight: '600',
        fontFamily: 'Montserrat',
        //padding: '10px'
    },
    fabButton: {
        backgroundColor: "transperent",
        color: "#DE350B"
    },
    cell: {
        padding: "10px"
    }
};

const UserRow = (props) => {
    const { record, index } = props.value;
    const [value, setValue] = useState({});
    const navi = useNavigate();

    const { orgDetails } = useOrgDetailsQuery({ id: record.orgId },
        {
            selectFromResult: ({ data }) => ({
                orgDetails: data || {},
            })
        }
    );

    const { roleDetails } = useGetRoleByCodeQuery({ code: record.role },
        {
            skip: !record.role,
            selectFromResult: ({ data }) => ({
                roleDetails: data || {}
            })
        }
    );

    const { cognitoDetails } = useUserCognitoDetailsQuery({ email: record.username },
        {
            skip: !record.username,
            selectFromResult: ({ data }) => ({
                cognitoDetails: data || {}
            })
        }
    );

    return (
        <React.Fragment>
            <TableRow sx={index % 2 === 0 ? classes.evenRow : classes.oddRow} onClick={() => navi(`/users/details/${record?.id}`)}>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4">{`${record?.firstName || ''} ${record?.lastName || ''}`}</Typography>
                </TableCell>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4">{record.username}</Typography>
                </TableCell>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4">{record.phone_number}</Typography>
                </TableCell>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4">{orgDetails.name || ''}</Typography>
                </TableCell>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4">{roleDetails.name || ''}</Typography>
                </TableCell>
                <TableCell sx={classes.cell}>
                    {cognitoDetails.UserCreateDate ?
                        <Typography variant="h4" align="left">{moment(cognitoDetails.UserCreateDate).tz('America/Los_Angeles').format('MMM D, YYYY')}</Typography>
                        :
                        <Typography variant="h4" align="left"> </Typography>}
                </TableCell>
                <TableCell sx={classes.cell}>
                    <Typography variant="h4" color="secondary">
                        {cognitoDetails.UserStatus === 'CONFIRMED' ?
                            "Active" :
                            cognitoDetails.UserStatus === 'FORCE_CHANGE_PASSWORD' ?
                                "Change Password" : "Inactive"}
                    </Typography>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default UserRow;